import { useMemo } from 'react';
import { useFormContext } from 'react-hook-form';

import { ReceivingMethod } from '../../../../api/def_common_api';
import { Util } from '../../../../common/util/util';
import { useBasket } from '../../../../hooks/useBasket';

export const useYourOrder = () => {
  const { order_sum, order_quantity: orderQuantity } = useBasket();
  const { getValues } = useFormContext();

  const typeDelivery = getValues('receiving_method');
  const priceDelivery = 500; // Цена доставка
  const orderSum = Util.convertKopecksToRub(order_sum).toLocaleString();
  const totalPrice =
    typeDelivery === ReceivingMethod.SelfDelivery
      ? Util.convertKopecksToRub(order_sum).toLocaleString()
      : (Util.convertKopecksToRub(order_sum) + priceDelivery).toLocaleString();

  return useMemo(
    () => ({
      order: {
        orderSum: orderSum,
        orderQuantity,
        typeDelivery,
        priceDelivery,
        totalPrice,
      },
    }),
    [orderSum, typeDelivery, priceDelivery, totalPrice, orderQuantity]
  );
};
